module.exports = __webpack_public_path__ + "img/firsthero.63beec61.svg";